import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  fields: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    width: '100%',
  },
  row: {
    display: 'flex',
    gap: theme.spacing(3), // 24px — Figma gap between Input fields
    width: '100%',
  },
  // Figma: 380 + 24 + 380 = 784 content → each field is half of row minus gap
  field: {
    width: `calc((100% - ${theme.spacing(3)}) / 2)`,
    minWidth: 0,
    flexShrink: 0,
    '& > *': {
      width: '100%',
    },
  },
  // TextInputV4 ignores endAdornment; % | (i) matches Figma / SelectV4
  percentWithInfo: {
    '& .MuiInputAdornment-positionEnd': {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1.25),
      '&::before': {
        content: '"%"',
        color: theme.palette.textField.main,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.spacing(1.75),
        lineHeight: theme.spacing(2.5),
      },
      '& > div': {
        display: 'inline-flex',
        alignItems: 'center',
        '&::before': {
          content: '""',
          display: 'block',
          width: theme.spacing(0.125),
          height: theme.spacing(3),
          marginRight: theme.spacing(1.25),
          backgroundColor: theme.palette.dividerV2.main,
          borderRadius: theme.spacing(0.5),
        },
      },
    },
  },
  percentSuffix: {
    '& .MuiInputBase-root::after': {
      content: '"%"',
      color: theme.palette.textField.main,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.spacing(1.75),
      lineHeight: theme.spacing(2.5),
      paddingRight: theme.spacing(1.5),
    },
  },
  headingWithInfo: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  info: {
    marginLeft: theme.spacing(1),
    // same as Internal stakeholders HelpDrawer info icon
    width: '16px',
    height: '16px',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '16px',
    letterSpacing: '0.15px',
    color: theme.palette.labraIcon.main,
  },
  tableSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: '100%',
  },
  tableTitle: {
    fontSize: theme.typography.body1.fontSize,
    lineHeight: theme.typography.body1.lineHeight,
    letterSpacing: theme.typography.body1.letterSpacing,
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary,
  },
  tableScrollWrap: {
    position: 'relative',
    width: '100%',
  },
  tableScroll: {
    width: '100%',
    // TableComponentV2 scrolls inside MuiTableContainer, not this wrapper
    '& .MuiTableContainer-root': {
      overflowX: 'auto',
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': {
        display: 'none',
        width: 0,
        height: 0,
      },
    },
    '& table': {
      minWidth: 'max-content',
    },
  },
  scrollNext: {
    position: 'absolute',
    right: 0,
    top: theme.spacing(1.5),
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // Figma Frame 1171276247: 20×20, chevrons-right 10×10
    width: theme.spacing(2.5),
    height: theme.spacing(2.5),
    padding: 0,
    border: 'none',
    borderRadius: '50%',
    cursor: 'pointer',
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.secondary,
    boxShadow: theme.shadows[2],
    fontSize: theme.spacing(1.25),
    '&[hidden]': {
      display: 'none',
    },
    '&:hover': {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
    },
  },
  renewalPrice: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    whiteSpace: 'nowrap',
  },
  upliftBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.25),
    color: theme.palette.success.main,
    fontSize: theme.typography.body2.fontSize,
    lineHeight: theme.typography.body2.lineHeight,
  },
  upliftArrow: {
    width: theme.spacing(1.5),
    height: theme.spacing(1.5),
    fontSize: theme.spacing(1.5),
  },
}))
